import clsx from 'clsx'

interface FilterButtonGroupProps<T extends string> {
  options: { label: string; value: T }[]
  value: T
  onChange: (value: T) => void
  size?: 'sm' | 'md'
  className?: string
}

export function FilterButtonGroup<T extends string>({
  options,
  value,
  onChange,
  size = 'md',
  className,
}: FilterButtonGroupProps<T>) {
  return (
    <div className={clsx('flex gap-1 bg-pitch-800 rounded-lg', size === 'sm' ? 'p-0.5' : 'p-1', className)}>
      {options.map((opt) => (
        <button
          key={opt.value}
          onClick={() => onChange(opt.value)}
          className={clsx(
            'rounded-md font-medium transition-colors',
            size === 'sm' ? 'px-3 py-1 text-xs' : 'px-3 py-1.5 text-sm',
            value === opt.value
              ? 'bg-accent text-white'
              : 'text-slate-400 hover:text-white',
          )}
        >
          {opt.label}
        </button>
      ))}
    </div>
  )
}
